import { axiosAjax } from '@app/src/config/axios';
import { isClientEnv } from '@app/src/utils/validations';

export const processConfirmService = {
  async postConsume(json: any): Promise<any> {
    const userStorage = isClientEnv() && JSON.parse(localStorage.getItem('user'));
    try {
      let config = {
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With':'XMLHttpRequest',
          'Authorization': `Bearer ${userStorage && userStorage.jwt}`
        }
      }

      const { data } = await axiosAjax.post(
        process.env.API_CONSUME_CONFIRM, {...json, token: userStorage && userStorage.jwt}, config
      );
      if (data.error) {
        throw new Error();
      }
      return data.data && data.data.length > 0 ? data.data[0] : {};
    } catch (e) {
      console.log('Error consume confirm service');
      throw new Error(e);
    }
  },
  async putPayment(json: any): Promise<any> {
    const userStorage = isClientEnv() && JSON.parse(localStorage.getItem('user'));
    try {
      let config = {
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With':'XMLHttpRequest',
          'Authorization': `Bearer ${userStorage && userStorage.jwt}`
        }
      }

      const { data } = await axiosAjax.put(
        process.env.API_PAYMENT_TRANSACTION
          .replace(':transactionId', '' + (window as any).transaction.id),
        JSON.stringify(json),
        config
      );
      if (data && data.error) {
        throw new Error();
      }
      return data.data && data.data.length > 0 ? data.data[0] : {};
    } catch (e) {
      console.log('Error consume confirm service');
      throw new Error(e);
    }
  },
}
